import Lang from '/@/modules/core/app/services/Lang';
import { LiabilityOwnershipMeta } from '/@/modules/liability/models/meta/LiabilityOwnershipMeta';

export class OtherCreditorLiabilityMeta extends LiabilityOwnershipMeta {
  /**
   * @var {string}
   */
  justification;

  /**
   * @var {string}
   */
  nameOfIssuer;

  /**
   * @var {boolean}
   */
  isRecurring;

  constructor(model = {}) {
    super(model);

    this.justification = model.justification;
    this.nameOfIssuer = model.nameOfIssuer;
    this.isRecurring = model.isRecurring ?? false;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return this.isRecurring ? Lang.t('guidancestep.recurring') : Lang.t('liability.non');
  }
}
